import { lazy } from 'react'
import { Route, Routes } from 'react-router-dom'

import i18n from 'modules/core/lib/i18n'
import { NavigationRoutesFn } from 'modules/core/lib/react-router'

const RootPage = lazy(() => import('modules/security_settings/pages/RootPage'))

const SecuritySettingsPage = lazy(
  () => import('modules/security_settings/pages/SecuritySettingsPage')
)

const BulkEmailChangePage = lazy(
  () => import('modules/security_settings/pages/BulkEmailChangePage')
)

export const securitySettingsRoutes: NavigationRoutesFn = (navigation) => {
  return [
    {
      path: navigation.settings.security.path,
      element: <RootPage />,
      children: [
        {
          index: true,
          element: <SecuritySettingsPage />,
        },
        {
          path: navigation.settings.security.bulkEmailChange.path,
          element: (
            <Routes>
              <Route path="" element={<BulkEmailChangePage />} />
            </Routes>
          ),
          handle: {
            resource: true,
            meta: () => ({
              title: i18n.t('security_settings.bulk_email_change.title'),
            }),
          },
        },
      ],
      handle: {
        meta: () => ({
          title: i18n.t('security_settings.title'),
          illustration: 'password-lock',
        }),
      },
    },
  ]
}
